/**
 * SATIŞ BAŞVURUSU — "Etkinliğinizi düzenleyin, bize ulaşın" formu
 * (kurum satışla açılır · Story B1, K3, V11-V13).
 *
 * Form kurum AÇMAZ, ödeme almaz: panelde satış adayı olur. Kapalı kümeler ve
 * sayısal sınırlar burada TEK yerdedir. Joi şeması (`contracts/sales-inquiry.ts`),
 * veritabanı CHECK'leri (migration) ve istemci formları aynı değeri okur.
 */
/** Etkinlik türü (V12): kapalı küme, serbest metin değil. */
export const SALES_INQUIRY_EVENT_TYPES = [
    'conference',
    'summit',
    'meetup',
    'fair',
    'internal',
    'training',
    'other',
];
/**
 * Başvurunun satış hattındaki durumu. Yalnız `new` ile doğar; diğer geçişler
 * panelin işidir (Story B4). `won` ve bir kuruma bağlı başvuru saklama süresine
 * tabi değildir (V13).
 */
export const SALES_INQUIRY_STATUSES = ['new', 'contacted', 'won', 'lost', 'spam'];
/** Sayısal ve takvim sınırları (V12). */
export const SALES_INQUIRY_LIMITS = {
    attendeesMin: 1,
    attendeesMax: 100_000,
    /** Tahmini tarih bugünden en fazla bu kadar yıl ileride olabilir. */
    maxYearsAhead: 3,
    contactName: { min: 2, max: 120 },
    note: { max: 2000 },
};
/**
 * ANONİM SATIRIN KATILIMCI KOVASI (K8 · aydınlatma metni "saklama" bölümü:
 * "yalnız etkinlik türü, tahmini katılımcı ARALIĞI, başvuru AYI kalır").
 * Anonimleştirmede tam sayı silinir, yerine kova yazılır. Kovaların üst
 * sınırları `SALES_INQUIRY_ATTENDEE_BAND_MAX` ile aynı sıradadır; son kova
 * üst sınırsızdır. Veritabanı CHECK'i (`ck_sales_inquiries_attendee_band`) ve
 * anonimleştirme SQL'i bu iki listeden üretilir.
 */
export const SALES_INQUIRY_ATTENDEE_BANDS = [
    '1-50',
    '51-200',
    '201-500',
    '501-1000',
    '1001-5000',
    '5001+',
];
/** Kovanın KAPSAYICI üst sınırı; `null` = sınırsız (son kova). */
export const SALES_INQUIRY_ATTENDEE_BAND_MAX = {
    '1-50': 50,
    '51-200': 200,
    '201-500': 500,
    '501-1000': 1000,
    '1001-5000': 5000,
    '5001+': null,
};
/** Tam katılımcı sayısı → kova (saf; sınırlar kapsayıcıdır). */
export function salesInquiryAttendeeBand(attendees) {
    for (const band of SALES_INQUIRY_ATTENDEE_BANDS) {
        const max = SALES_INQUIRY_ATTENDEE_BAND_MAX[band];
        if (max === null || attendees <= max)
            return band;
    }
    return '5001+';
}
/** Başvurunun okuduğu aydınlatma metninin slug'ı (`legal/registry`). */
export const SALES_INQUIRY_NOTICE_SLUG = 'satis-basvurusu';
/**
 * Tahmini tarih penceresi: `today` (YYYY-MM-DD, İstanbul takvimi) ile
 * `maxYearsAhead` yıl sonrası arası, iki uç DAHİL. Saf fonksiyon: saat
 * çağırandan gelir (zaman fikstürü kuralı, duvar saati okunmaz).
 */
export function isSalesInquiryDateInWindow(day, today) {
    if (day < today)
        return false;
    const [year, rest] = [Number(today.slice(0, 4)), today.slice(4)];
    const limit = `${String(year + SALES_INQUIRY_LIMITS.maxYearsAhead).padStart(4, '0')}${rest}`;
    return day <= limit;
}
/**
 * KURUM TALEBİ (B-21, kullanıcı kararı 09.10.2026). Giriş yapmış kurum hesabının
 * "bize ulaş" kaydı: yeni satış başvurusu DEĞİLDİR, var olan kuruma bağlı
 * talep olarak aynı tabloya yazılır (`sales_inquiries.topic` dolu satır). Konu
 * kapalı kümedir; veritabanı CHECK'i (`ck_sales_inquiries_topic`) aynı listeyi
 * okur.
 */
export const ORGANIZATION_REQUEST_TOPICS = [
    'credit_topup',
    'enterprise_contract',
    'support',
    'other',
];
/**
 * Kredi yükleme konusunun paket seçimi. Deneme kredisi satın alınmaz, listede
 * yoktur. Fiyat bu listeden okunmaz (`CREDIT_PACKAGE_DEFINITIONS`).
 */
export const ORGANIZATION_REQUEST_PACKAGES = ['single', 'pack_12', 'enterprise'];
//# sourceMappingURL=sales-inquiry.js.map